export default __webpack_public_path__ + "static/media/camera-icon.5e11b249.svg";